import Vue from 'vue';

const MILLISECONDS_MULTIPLIER = 1000;

export const events = new Vue({ name: 'BravadoCancelableNoticeEvents' });

type CounterEvent = (value: number, id: string) => void

export class CountDown {
  private shouldStop: boolean = false;
  private count: number;
  private id: string;
  private onCounterUpdate: CounterEvent;
  private onProgressUpdate: CounterEvent;

  constructor(count: number, id: string, onCounterUpdate: CounterEvent, onProgressUpdate: CounterEvent) {
    this.count = count;
    this.id = id;
    this.onCounterUpdate = onCounterUpdate;
    this.onProgressUpdate = onProgressUpdate;
  }

  start() {
    const endTime = new Date().getTime() + this.count * MILLISECONDS_MULTIPLIER;
    let currentCount = this.count;

    const getRemainingCount = (deadline: number) => {
      const currentTime = new Date().getTime();
      return deadline - currentTime;
    };

    this.onCounterUpdate(this.count, this.id);

    const updateCounter = () => {
      const remainingCount = getRemainingCount(endTime);
      const count = Math.round((remainingCount / MILLISECONDS_MULTIPLIER) % 60);
      const progress = Math.abs(Math.round((remainingCount / (this.count * MILLISECONDS_MULTIPLIER)) * 100) - 100);

      this.onProgressUpdate(progress, this.id);

      if (count < currentCount && count >= 0) {
        currentCount = count;
        this.onCounterUpdate(count, this.id);
      }

      if (remainingCount >= 0 && !this.shouldStop) {
        requestAnimationFrame(updateCounter);
      }
    };

    requestAnimationFrame(updateCounter);
  }

  stop() {
    this.shouldStop = true;
  }
}

export class CancelableNoticeError extends Error {
  constructor(message: string) {
    super(message);
    Error.captureStackTrace(this, CancelableNoticeError);
  }
}
